export enum MouseUserEvent {
  Click = 'click',
  Dragend = 'dragend',
  Dragmove = 'dragmove',
  Dragstart = 'dragstart',
  DragEnter = 'dragenter',
  DragOver = 'dragover',
  DragLeave = 'dragleave',
  Drop = 'drop',
  Mousedown = 'mousedown',
  Mouseenter = 'mouseenter',
  Mouseleave = 'mouseleave',
  Mousemove = 'mousemove',
  Mouseout = 'mouseout',
  Mouseover = 'mouseover',
  Mouseup = 'mouseup',
  Touchend = 'touchend',
  Touchmove = 'touchmove',
  Touchstart = 'touchstart',
}

export enum MobileUserEvent {
  Dragstart = 'dragstart',
  Dragmove = 'dragmove',
  Dragend = 'dragend',
  Tap = 'tap',
  Dbltap = 'dbltap',
  Touchstart = 'touchstart',
  Touchmove = 'touchmove',
  Touchend = 'touchend',
}
